import React from 'react';
import { ContentCard, ContentWrapper } from '../../common/components/ContentCard';
import { CountryFilter, ErrorMessage, UpdateChargebackOptions } from '@card/commonlib';
import { Currency as CurrencyType } from '@card/types';
import { useDispatch } from 'react-redux';
import { ChargebacksActions } from './actions';
import { useTranslation } from 'react-i18next';
import List from './components/List';
import { DateRangeInput, FilterButton } from '@increasecard/typed-components';
import TotalNumberBox from './components/TotalNumberBox';
import { useChargebacksScreen } from './useChargebacksScreen';
import { Field } from '@increasecard/typed-components/dist/types/Field';
import { useChargebacksData } from './useChargebacksData';
import { CurrencyTabs } from '../../common/components/CurrencyTabs';
import { CreateReportButton } from '../../common/components/report/CreateReportButton';
import { ActionButtons, ActionHeader, FilterGroup } from '../../common/components/ActionHeader';

export function ChargebacksScreen() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    filterFields,
    setFilters,
    filters,
    setDateRangeInput,
    dateRangeInput
  } = useChargebacksScreen();

  const {
    list,
    setPage,
    currentCurrency,
    setCurrentCurrency,
    handleCreateReport
  } = useChargebacksData({
    filters,
    dateRangeInput
  });

  const handleErrorMessageClick = () => setPage(list.settings.current_page);

  const handleDataChanged = (params: UpdateChargebackOptions) =>
    dispatch(ChargebacksActions.updateDataStarted(params));

  if (list.error) {
    return (
      <ContentCard>
        <ContentWrapper>
          <ErrorMessage onErrorMessageClick={handleErrorMessageClick}>
            {t('api:errors:default')}
          </ErrorMessage>
        </ContentWrapper>
      </ContentCard>
    );
  }

  return (
    <ContentCard>
      <>
        <CountryFilter
          hideFor={['argentina', 'ecuador', 'dominicana', 'chile', 'colombia', 'paraguay']}
        >
          <CurrencyTabs onChange={setCurrentCurrency} value={currentCurrency as CurrencyType} />
        </CountryFilter>
        <ContentWrapper>
          <ActionHeader>
            <FilterGroup>
              <DateRangeInput
                id="chargebacksDateRangeInput"
                label=""
                labelHidden
                onChange={setDateRangeInput}
                style={{ width: 280 }}
                value={dateRangeInput}
              />
              <FilterButton
                fields={filterFields as Field[]}
                onChange={setFilters}
                value={filters}
              />
            </FilterGroup>
            <ActionButtons>
              <CreateReportButton
                onCreateReport={handleCreateReport}
                targetText={t('chargebacks:chargebacks')}
                translationFunction={t}
              />
            </ActionButtons>
          </ActionHeader>
          <TotalNumberBox
            currency={currentCurrency as CurrencyType}
            title={t('chargebacks:totalBox:description')}
            value={list.fetching ? undefined : list.settings.total}
          />
          <List
            chargebacks={list.data}
            currency={currentCurrency}
            currentPage={list.settings.current_page}
            fetchingData={list.fetching}
            onDataChanged={handleDataChanged}
            onPageSelected={setPage}
            totalPages={list.settings.total_pages}
          />
        </ContentWrapper>
      </>
    </ContentCard>
  );
}
